import FBaseService from '../FBaseService';
import { AxiosResponse } from 'axios';
import { PortalAppStatus } from './types';
import { ResponseEnvelope } from '..';

export default class PortalAppService extends FBaseService {

	getPortalAppStatus(): Promise<AxiosResponse<ResponseEnvelope<PortalAppStatus>>> {
		return this.apiClient.get<ResponseEnvelope<PortalAppStatus>>('/api/session/portalapp-status');
	}
	protected async handleForbidden(): Promise<void> {
		// fail silently
		return;
	}

	protected async handleUnauthenticated(): Promise<void> {
		// fail silently
		return;
	}

	protected async hanldeServerError(): Promise<void> {
		// fail silently
		return;
	}

}